<template>
  <b-dropdown @input="onInput" position="is-bottom-left">
    <button
      class="button is-primary"
      type="button"
      slot="trigger"
      :class="{ 'is-loading': processing, 'is-outlined': !innerValue }"
    >
      <template v-if="innerValue">
        <b-icon icon="earth"></b-icon>
        <span>{{$tc('support_ticket.status.published')}}</span>
      </template>

      <template v-else>
        <b-icon icon="lock"></b-icon>
        <span>{{$tc('support_ticket.status.unpublished')}}</span>
      </template>

      <b-icon icon="menu-down"></b-icon>
    </button>

    <b-dropdown-item :value="true">
      <div class="media">
        <b-icon class="media-left" icon="earth"></b-icon>
        <div class="media-content">
          <h3>{{$tc('support_ticket.status.published')}}</h3>
          <small>Visible in the app</small>
        </div>
      </div>
    </b-dropdown-item>

    <b-dropdown-item :value="false">
      <div class="media">
        <b-icon class="media-left" icon="lock"></b-icon>
        <div class="media-content">
          <h3>{{$tc('support_ticket.status.unpublished')}}</h3>
          <small>Only visible to the admin.</small>
        </div>
      </div>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },

    uri: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      processing: false,
      innerValue: this.value
    };
  },

  watch: {
    value(value) {
      this.innerValue = value;
    }
  },

  methods: {
    onInput(status) {
      this.processing = true;

      this.$http[status ? "post" : "delete"](this.uri)
        .takeAtLeast(1500)
        .then(() => {
          this.innerValue = status;

          if (status) {
            this.notify();
          }

          this.processing = false;
        })
        .catch(error => {
          this.processing = false;

          new window.FailedResponseHandler(error).handle();
        });
    },

    notify() {
      this.$buefy.toast.open({
        type: "is-success",
        message: "Successfully published.."
      });
    }
  }
};
</script>
